/**
 * CinematicEvents — Event constants for the cinematic tutorial system.
 * All cinematic communication flows through EventBus using these keys.
 */

export const CinematicEvents = {
  /** Trigger a cinematic sequence. Payload: { sequenceId: string } */
  START: 'cinematic:start',
  /** Emitted when a step begins. Payload: { stepIndex: number, stepType: string } */
  STEP_STARTED: 'cinematic:stepStarted',
  /** Emitted when a step completes */
  STEP_DONE: 'cinematic:stepDone',
  /** Emitted when the entire sequence finishes. Payload: { sequenceId: string } */
  COMPLETE: 'cinematic:complete',
  /** Player requests skip */
  SKIP: 'cinematic:skip',
  /** Force immediate halt — no fast-forward, no completion event */
  FORCE_STOP: 'cinematic:forceStop',

  // ── Sub-component signals ──
  BUBBLE_DISMISSED: 'cinematic:bubbleDismissed',
  FAKE_CLICK_DONE: 'cinematic:fakeClickDone',
  CAMERA_PAN_DONE: 'cinematic:cameraPanDone',
  RECAP_CLOSED: 'cinematic:recapClosed',
  DEMO_WAVE_DONE: 'cinematic:demoWaveDone',
  SPOTLIGHT_CLICKED: 'cinematic:spotlightClicked',

  // ── Action events (DemoWaveRunner → UIScene) ──
  AUTO_PLACE_ROBOT: 'cinematic:autoPlaceRobot',
  SELECT_PRESET: 'cinematic:selectPreset',
} as const;
